import { buildResponsiveCSS } from '../../../utils/css.mjs';
import { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import NewsletterBackgroundBig from './NewsletterBackgroundBig.mjs';
import NewsletterBackgroundSmall from './StyledNewsletterBackgroundSmall.mjs';
import styled from 'styled-components';

const StyledNewsletterBackgroundBig = styled(NewsletterBackgroundBig) `
  position: absolute;
  z-index: -1;
  right: 0;
  bottom: 0;
`;
const StyledNewsletterBackgroundSmall = styled(NewsletterBackgroundSmall) `
  position: absolute;
  z-index: -1;
  right: 0;
  top: 1rem;
`;
const StyledNewsLetterWrapper = styled.section `
  ${props => {
    var _a;
    return buildResponsiveCSS('padding', (_a = props.padding) !== null && _a !== void 0 ? _a : { default: '1.375rem 1rem 2.5rem', lg: '1.75rem 3.75rem' });
}};
  background: ${props => props.theme.colors.skyBlue};
  position: relative;
  z-index: 0;

  & > ${StyledHeading} {
    @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
      margin-top: 19px;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      margin-top: 0;
    }

    margin-bottom: 0.375rem;
  }

  & > p {
    @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
      font-size: 0.875rem;
      margin-top: 10px;
      margin-bottom: 23px;
    }
    margin-bottom: 0.75rem;
  }

  & > ${StyledHeading}, & > p {
    color: ${props => props.theme.colors.white};
  }
`;

export { StyledNewsLetterWrapper, StyledNewsletterBackgroundBig, StyledNewsletterBackgroundSmall };
//# sourceMappingURL=Newsletter.styles.mjs.map
